import { styled } from 'next-yak';
import type {
  ComponentProps,
  ForwardRefExoticComponent,
  RefAttributes,
} from 'react';

import { MiniBadge as MiniMadgeComponent } from '@xing-com/badge';
import type { Link } from '@xing-com/link';
import { SingleSelect } from '@xing-com/menu';
import type { SingleSelectProps } from '@xing-com/menu';
import {
  cornerRadiusL,
  scale080,
  spaceL,
  spaceM,
  spaceS,
  xdlColorHover,
  xdlColorText,
} from '@xing-com/tokens';

// More items already accept the same router destinations as Link.
// oxlint-disable-next-line typescript/consistent-type-assertions
const MoreItemSelect = SingleSelect as ForwardRefExoticComponent<
  Omit<SingleSelectProps, 'to'> &
    Pick<ComponentProps<typeof Link>, 'to'> &
    RefAttributes<HTMLButtonElement | HTMLAnchorElement>
>;

// *** Components ***
const MoreListItem = styled(MoreItemSelect)`
  background-color: transparent;
  border-radius: ${cornerRadiusL};
  border-width: 0;
  color: ${xdlColorText};
  display: flex;
  font-size: ${scale080};
  font-weight: inherit;
  height: auto;
  justify-content: flex-start;
  outline: 0;
  padding-bottom: ${spaceM};
  padding-left: ${spaceL};
  padding-right: ${spaceL};
  padding-top: ${spaceM};
  width: 100%;

  &:focus,
  &:hover {
    background: ${xdlColorHover};
    color: ${xdlColorText};
    cursor: pointer;
    text-decoration: none;
  }
`;

const MoreItemInner = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
`;

const MiniBadge = styled(MiniMadgeComponent)`
  margin-right: ${spaceS};
`;

const MoreItemIcon = styled.div`
  line-height: 0;
  margin-right: ${spaceS};
`;

export const Styled = {
  MiniBadge,
  MoreItemIcon,
  MoreItemInner,
  MoreListItem,
};
